import { create } from 'zustand';
import type { Deal } from '@/features/pipeline/types';

/**
 * Estado global do modal de handoff ("Mover para Portfólio"). Acionado pela ficha do Deal; o
 * `<HandoffModal/>` é renderizado uma vez no shell e lê esta store. Carrega o Deal de origem para
 * pré-preencher codinome e responsável.
 */
interface HandoffState {
  deal: Deal | null;
  open: (deal: Deal) => void;
  close: () => void;
}

export const useHandoff = create<HandoffState>()((set) => ({
  deal: null,
  open: (deal) => set({ deal }),
  close: () => set({ deal: null }),
}));
